window.addEventListener("load", function() {
  const images = document.querySelectorAll('.lazy_load');
  const config = {
    rootMargin: '50px 0px',
    threshold: 0.01
  };
  let imageCount = images.length;
  let observer;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(onIntersection, config);

    images.forEach(function(image) { 
      observer.observe(image);
    })
  } else {  
    var lazyloadThrottleTimeout;
    lazyloadImages = $(".lazy_load");
    function lazyload () {
      if(lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }    
      lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = $(window).scrollTop();
        lazyloadImages.each(function() {
            var el = $(this);
            if(el.offset().top < window.innerHeight + scrollTop + 200) {
              var url = el.attr("data-src");
              el.attr("src", url);
              el.on('load', function(){
                el.addClass('loaded')
              })
              lazyloadImages = $(".lazy_load");
            }
        });
        if(lazyloadImages.length == 0) { 
          $(document).off("scroll");
          $(window).off("resize");
        }
      }, 20);
    }
    lazyload();
    document.addEventListener("scroll", lazyload);
    window.addEventListener("resize", lazyload);
    window.addEventListener("orientationChange", lazyload);
  }
  function fetchImage(url) {
    return new Promise(function(resolve, reject) {
      const image = new Image();
      image.src = url;
      image.onload = resolve;
      image.onerror = reject;
    });
  }
  function preloadImage(image) {
    const src = image.dataset.src;
    if (!src) {
      return;
    }
    return fetchImage(src).then(function() { applyImage(image, src); });
  }
  function disconnect() {
    if (!observer) {
      return;
    }
    observer.disconnect();
  }
  function onIntersection(entries) {
    if (imageCount === 0) {
      disconnect();
      return;
    }
    entries.forEach(function(entry) { 
      if (entry.intersectionRatio > 0) {
        imageCount--;
        observer.unobserve(entry.target);
        preloadImage(entry.target);
      }
    })
  }
  function applyImage(img, src) {
    img.classList.add('loaded');
    img.src = src;
  }
})